import { NotepadPanel } from './NotepadPanel';

interface Props {
  jobId: string;
  onClose: () => void;
  onCountChange?: (count: number) => void;
}

/**
 * Mid-shoot bottom sheet that wraps the shared NotepadPanel.
 * Spec calls for pausing the post-shot countdown while this is open — we already
 * removed that countdown, so no pause handshake needed.
 */
export function NotepadSheet({ jobId, onClose, onCountChange }: Props) {
  return (
    <div className="fixed inset-0 z-40 bg-black/60" onClick={onClose}>
      <div
        className="absolute inset-x-0 bottom-0 flex h-[85vh] flex-col rounded-t-2xl bg-white"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mx-auto mt-2 h-1 w-10 shrink-0 rounded-full bg-gray-300" />
        <NotepadPanel
          jobId={jobId}
          onClose={onClose}
          onCountChange={onCountChange}
        />
      </div>
    </div>
  );
}
